import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './belief.json';

const Belief = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Belief systems, religion, and worldview vocabulary. B2/C1 level grammar, reading, and discussion exercises."
            level="B2"
            title="Belief"
            image="/Images/belief.webp"
            seoTitle="Free English Lesson Plans: Belief"
            seoDescription="Belief systems, religion, and worldview vocabulary. B2/C1 level grammar, reading, and discussion exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Belief;


